/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `HelpPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  ForgotPasswordTitle: `نسيت اسم المستخدم و / أو كلمة المرور`,
  ForgotUsername: `1. من صفحة تسجيل الدخول ، انقر فوق الرابط "هل تحتاج إلى مساعدة لتسجيل الدخول".`,
  ForgotUsername2: `2. انقر فوق الرابط "نسيت كلمة المرور"`,
  ForgotUsername3: `3. أدخل قائمة عناوين البريد الإلكتروني في حساب المستخدم وانقر فوق الزر "إرسال البريد الإلكتروني".`,
  ForgotUsername4: `4. ابحث في علبة الوارد الخاصة بك (مع ملاحظة أنه قد يكون في البريد غير المرغوب فيه) الخاص بالبريد الإلكتروني الخاص بالنظام واتبع التعليمات.`,
  PageHeading: ({ name }) => name,
  PageTab: `مساعدة`,
  PageTitle: `تسجيل الدخول مساعدة`,
  Redirect: `العودة إلى تسجيل الدخول`,
  Report: `الإبلاغ عن مشكلة أمنية أو تقنية`,
  SecurityIssue: `1. انقر على علامة التبويب "التعليقات" باللون الأخضر على يسار الصفحة`,
  SecurityIssue2: `2. أدخل عنوان بريدك الإلكتروني وتعليقاتك في النموذج.`,
  SecurityIssue3: `3. انقر فوق "إرسال" زر.`,
  SecurityIssue4: `4. إذا كانت مشكلتك تتطلب استجابة ، فسيكون أحد الممثلين على اتصال.`,
  SecurityIssue5: `بالنسبة للمشكلات المتعلقة بالخدمة ، يرجى الاتصال بممثل حسابك أو مركز خدمة العملاء.`,
  SignIn: `تسجيل الدخول إلى Boral Connects`,
  SignInHelp: `Boral Connects هو تطبيق ويب حسب الطلب متاح على كل من سطح المكتب والجوّال الذي يدعم عملاء Boral Concrete الذين يديرون طلباتهم وعمليات التسليم.`,
  SignInHelpParagraph: `بمجرد تسجيل الدخول ، تعرض Boral Connects جميع طلباتك بدءًا من اليوم
                        الحالي. باستخدام عناصر التحكم في التنقل ، يمكنك عرض الطلبات حسب التاريخ والحالة والعنوان.`,
  SignInList1: `1. افتح متصفح ويب وقم بزيارة Boral Connects`,
  SignInList1a: `https://portal.boralconnects.com.au`,
  SignInList2: `2. أدخل اسم المستخدم أو عنوان البريد الإلكتروني وكلمة المرور ، ثم انقر فوق "تسجيل الدخول"`,
  SignInList3: `3. إذا رأيت رسالة الخطأ "فشل تسجيل الدخول" ، لا يتطابق اسم المستخدم وكلمة المرور مع تلك المحددة لملفك الشخصي.`,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  ForgotPasswordTitle: `Forgot username and/or password`,
  ForgotUsername: `1. From the login page click 'Need help signing in' link.`,
  ForgotUsername2: `2. Click 'Forgot password' link`,
  ForgotUsername3: `3. Enter the email address list on the user account and click 'Send Email' button.`,
  ForgotUsername4: `4. Look in your inbox (noting that it may be in your junk mail) for the system generated email and follow the prompts.`,
  PageHeading: ({ name }) => name,
  PageTab: `Help`,
  PageTitle: `Sign-In Help`,
  Redirect: `Back to Login `,
  Report: `Report a security or technical issue`,
  SecurityIssue: `1. Click on the green 'Feedback' tab on the right of the page.`,
  SecurityIssue2: `2. Enter your email address and comments in the form.`,
  SecurityIssue3: `3.  Click 'Send' button.`,
  SecurityIssue4: `4. If your issue requires a response, a representative will be in touch.`,
  SecurityIssue5: `For service related issues please contact your account representative or customer service centre.`,
  SignIn: `Sign-in to Boral Connects`,
  SignInHelp: `Boral Connects is an on-demand
               web application available on both desktop and mobile that supports Boral Concrete customers managing their orders and deliveries.`,
  SignInHelpParagraph: `Once you sign in, Boral Connects displays all your orders
                        starting with the current day. Using the navigation controls you can view orders by date, status and address.`,
  SignInList1: `1. Open a web browser and visit Boral Connects`,
  SignInList1a: `https://portal.boralconnects.com.au`,
  SignInList2: `2. Enter your username or email address and password, and then click 'Sign-in'.`,
  SignInList3: `3. If you see the error message 'Sign in failed', your username and password do not match those specified for your profile.`,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  ForgotPasswordTitle: `忘記用戶名和/或密碼`,
  ForgotUsername: `1.在登錄頁面中，單擊“需要幫助登錄”鏈接。`,
  ForgotUsername2: `2.單擊“忘記密碼”鏈接`,
  ForgotUsername3: `3.在用戶帳戶中輸入電子郵件地址列表，然後單擊“發送電子郵件”按鈕。`,
  ForgotUsername4: `4.查看系統生成的電子郵件中的收件箱（注意它可能在您的垃圾郵件中）並按照提示操作。`,
  PageHeading: ({ name }) => name,
  PageTab: `救命`,
  PageTitle: `登錄幫助`,
  Redirect: `回到登入`,
  Report: `報告安全或技術問題`,
  SecurityIssue: `1。點擊頁面右側的綠色“反饋”標籤。`,
  SecurityIssue2: `2.在表單中輸入您的電子郵件地址和評論。`,
  SecurityIssue3: `3。點擊“發送”按鈕。`,
  SecurityIssue4: `4.如果您的問題需要回复，代表將與您聯繫。`,
  SecurityIssue5: `有關服務相關問題，請聯繫您的客戶代表或客戶服務中心。`,
  SignIn: `登錄Boral連接`,
  SignInHelp: `Boral Connects是桌面和移動設備上的按需Web應用程序，支持Boral Concrete客戶管理他們的訂單和交付。`,
  SignInHelpParagraph: `登錄後，Boral Connects會顯示從當天開始的所有訂單。使用導航控件，您可以按日期，狀態和地址查看訂單。`,
  SignInList1: `1.打開網絡瀏覽器並訪問Boral Connects`,
  SignInList1a: `https://portal.boralconnects.com.au`,
  SignInList2: `2.輸入您的用戶名或電子郵件地址和密碼，然後單擊“登錄”。`,
  SignInList3: `3.如果您看到錯誤消息“登錄失敗”，則您的用戶名和密碼與為您的配置文件指定的用戶名和密碼不匹配。`,
});
